export const TRUNCATION_SYMBOL = '...'

export const THROTTLE_DELAY_MS = 100
